import type { SVGProps } from "react";

export default function LogoutIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 360.04 361.16"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<g>
				{/* Black parts - use currentColor */}
				<path fill="currentColor" d="M33.82.16l143.6-.16c52.42,7.88,29.72,70.86,34.65,107.4-1.28,10.83-15.26,11.36-16.94-1.11-2.98-22.14,3.34-52.13-.33-73.67-1.6-9.41-10.32-15-19.22-15.78-44.65-3.87-94.81,2.97-140.04.03-9.49,1.41-16.87,7.91-18.52,17.48l-.03,290.08c1,10.1,8.82,16.97,18.55,18.45,45.23-2.94,95.39,3.9,140.04.03,8.91-.77,17.62-6.37,19.22-15.78,3.66-21.55-2.65-51.53.33-73.67,1.52-11.25,13.47-12.89,16.86-2.03-1.83,24.05,2.7,52.29-.05,75.84-2.06,17.64-18.79,31.89-36.36,32.64-45.1-3.11-95.55,4.04-140.02-.05-19.54-1.8-34.26-16.81-35.55-36.45L.05,35.39C1.77,16.72,15.32,2.67,33.82.16Z" />
				{/* Green parts - keep fixed color */}
				<path fill="#3fdfcf" d="M331.04,187.88H76.54c-6.97,0-6.97-16,0-16h254.5l-74.54-73.95c-6.25-8.06,3.33-17.58,11.6-11.6l89.48,87.51c2.92,3.67,3.63,8.62-.02,12.06l-89.99,88.01c-8.3,5.17-17.19-4.47-11.07-12.07l74.54-73.95Z" />
			</g>
		</svg>
	);
}

